const data = [
  {
    id: 1,
    question: "Is this a job or an internship?",
    answer:
      "This is a Data Science Training and Internship – Certificate Program, not a direct job offer. The program is designed to make candidates job-ready through structured learning, real-world projects, and 1:1 mentorship aligned with industry expectations."
  },

  {
    id: 2,
    question:
      "Why was this program created, and how does it differ from other training or internship programs?",
    answer:
      "Through extensive experience working with UK-based employers and ongoing industry discussions, we identified a clear gap: employers seek practical, hands-on, UK-relevant experience rather than just academic certificates. Many capable candidates struggle due to limited exposure to real-world projects and industry workflows. This program bridges that gap through real-world projects, hands-on datasets, continuous 1:1 mentorship from UK-based professionals, and a structure that mirrors real working environments. Our goal is not just to train candidates, but to prepare them for the realities of the UK job market."
  },

  {
    id: 3,
    question: "Is the internship paid or unpaid?",
    answer:
      "This is an unpaid training and internship program. The focus is on hands-on experience, real-world projects, mentorship, and portfolio building — all of which employers actively seek."
  },

  {
    id: 4,
    question: "What is the duration of the program?",
    answer:
      "The program runs for 3 months. Months 1 and 2 focus on learning, tasks, assignments, and mini-projects. Month 3 involves real-world projects assigned by your mentor."
  },

  {
    id: 5,
    question: "Are the projects real-world or simulated?",
    answer:
      "All projects are real-world and industry-aligned, covering domains such as Banking & Finance, Forex, Retail, Healthcare, and Hospitality. They are designed to reflect real business problems and strengthen your professional portfolio."
  },

  {
    id: 6,
    question: "Who assigns the projects?",
    answer:
      "Projects are assigned and reviewed by your dedicated UK-based mentor based on your progress, skill level, and career goals."
  },

  {
    id: 7,
    question: "Is there a fixed class schedule?",
    answer:
      "No. The program is fully remote, flexible, and self-paced within weekly milestones. There are no fixed daily classes."
  },

  {
    id: 8,
    question: "How many hours per week are required?",
    answer:
      "Participants typically dedicate 6–8 hours per week. This includes learning modules, assignments and projects, and a weekly 30–45 minute mentor session."
  },

  {
    id: 9,
    question: "Will I get mentorship?",
    answer:
      "Yes. You will receive weekly 1:1 live mentorship sessions with a UK-based industry professional to review work, clarify doubts, receive career guidance, and improve job readiness."
  },

  {
    id: 10,
    question: "What certification will I receive?",
    answer:
      "Upon successful completion, you will receive a Microsoft-partnered certificate. Int-Elligence Tech Solutions Plc is a registered Microsoft Partner, strengthening the certificate’s credibility in the UK and globally."
  },

  {
    id: 11,
    question: "Is this program free?",
    answer:
      "Yes. The program is free for the full 3-month duration. The only cost is a nominal registration fee that covers administrative costs."
  },

  {
    id: 12,
    question: "What is the registration fee?",
    answer:
      "The standard registration fee is £200. Fast-Track Selection candidates receive a 15% discount, reducing it to £170. In special circumstances, further reductions or instalment plans may be offered. There are no hidden charges."
  },

  {
    id: 13,
    question: "Can the registration fee be paid in instalments?",
    answer:
      "Yes. Flexible instalment plans of two or three payments are available to make the fee financially manageable."
  },

  {
    id: 14,
    question: "Do you guarantee a job after completion?",
    answer:
      "No ethical organization can guarantee a job. However, top-performing candidates may be shortlisted for interviews or offered project-based roles. The program significantly improves employability through real-world experience."
  },

  {
    id: 15,
    question: "Can I start later if I am busy or travelling?",
    answer:
      "Yes. Multiple cohorts run every month. You may join a later cohort if seats are available, though advance enrollment is recommended."
  },

  {
    id: 16,
    question: "Can international candidates apply?",
    answer:
      "Yes. International candidates may apply subject to review. UK and EU candidates are prioritised, but strong international profiles may still be considered."
  },

  {
    id: 17,
    question: "Can I work full-time while doing the program?",
    answer:
      "Yes. The program is designed specifically for working professionals and students who require flexibility."
  },

  {
    id: 18,
    question: "What skills will I gain?",
    answer:
      "You will gain practical experience in Python, SQL, data analysis, machine learning, data visualization, model building and evaluation, working with real datasets, and industry problem-solving."
  },

  {
    id: 19,
    question: "How do I secure my place?",
    answer:
      "Once shortlisted, you confirm your interest, receive an invoice, pay the first instalment to reserve your seat, and complete onboarding. Seats are limited per cohort."
  },

  {
    id: 20,
    question: "What happens if I don’t respond after being selected?",
    answer:
      "Due to limited capacity, if we do not receive a response or payment within the stated timeline, the seat may be allocated to another candidate."
  },

  {
    id: 21,
    question: "Who should I contact for queries?",
    answer:
      "All official communication is handled via email. If required, a short call may be arranged, but candidates are expected to respond to emails first for documentation and clarity."
  }
];

export default data;
